import { useSearch } from "@tanstack/react-router";
import { useTranslations } from "use-intl";

import { Button } from "@lawline/ui/components/button";

import { authClient } from "@platform/auth/client";
import { CreateTenant } from "./components/create-tenant";
import { DeleteTenant } from "./components/delete-tenant";
import { LeaveTenant } from "./components/leave-tenant";
import { MembersSection } from "./components/members-section";
import { TenantIdentity } from "./components/tenant-identity";

export function TenantPage() {
	const t = useTranslations("tenant");
	const { create } = useSearch({ from: "/shell/tenant" });
	const { data: tenants, isPending, error } = authClient.useListOrganizations();

	if (isPending) return null;

	if (error || !tenants) {
		return (
			<div className="mx-auto flex max-w-sm flex-col gap-3 py-12">
				<p role="alert">{t("loadError")}</p>
				<Button variant="outline" onClick={() => window.location.assign("/tenant")}>
					{t("create.checkOrganisations")}
				</Button>
			</div>
		);
	}

	if (create || tenants.length === 0) {
		return <CreateTenant />;
	}

	return (
		<div className="mx-auto mt-2 w-full max-w-3xl">
			<div className="flex flex-col gap-8">
				<TenantIdentity />
				<MembersSection />
				<LeaveTenant />
				<DeleteTenant />
			</div>
		</div>
	);
}
